import React, { useState } from "react";
import DOMPurify from "dompurify";
import { useDispatch, useSelector } from "react-redux";
import { funcionalidades } from "../../../context/AuthContext";
import { apiRoutes } from "../../../hooks/apiClient";
import ParteServicoPaginatedView from "../../../components/UI/PaginatedView/ParteServicoPaginatedView";
import useFormBuscaAvancada from "./hooks/useFormBuscaAvancada";
import { paginatedViewActions } from "../../../redux/paginatedView";
import useColumns from "./hooks/useColumns";
import useExcluirParteServicoOs from "./hooks/useExcluirParteServicoOs";
import useEncerrarParteServicoOs from "./hooks/useEncerrarParteServicoOs";
import useDocumentoParteServico from "./hooks/useDocumentoParteServico";
import EfisModal from "../../../components/UI/EfisModal/EfisModal";

const reduxKey = "parteServico";

const ParteServico = ({ history, match }) => {
  const { formik, form } = useFormBuscaAvancada();
  const { excluirPsModal, verificaPsExcluir } = useExcluirParteServicoOs({ formik });
  const { encerrarPsModal, verificaPs } = useEncerrarParteServicoOs({ formik });
  const { setDocParams } = useDocumentoParteServico();
  const { columns, showModal, setShowModal, textoCancelamento, textoOsSpf, tipoTexto } = useColumns({
    verificaPs,
    verificaPsExcluir,
    setDocParams,
  });

  const dispatch = useDispatch();

  useState(() => {
    // Desestruturando diretamente a partir de history.location.state?.paginatedViewState
    const { advancedSearchParams = {}, showAdvancedSearch = false } = history.location.state?.paginatedViewState || {};

    // Dispatch para salvar os parâmetros de pesquisa
    dispatch(paginatedViewActions.saveParams({ reduxKey, params: advancedSearchParams }));

    // Dispatch para mostrar ou ocultar a busca avançada
    dispatch(paginatedViewActions.setShowAdvancedSearch({ reduxKey, showAdvancedSearch }));

    // Dispatch para definir os parâmetros da barra de título
    dispatch(paginatedViewActions.setTitleBarParams({ reduxKey, titleBarParams: {} }));
  }, [dispatch, history.location.state?.paginatedViewState]);

  // Acessa o estado de 'showAdvancedSearch' no Redux
  const showAdvancedSearch = useSelector((state) => state.paginatedView[reduxKey]?.showAdvancedSearch);

  return (
    <>
      {excluirPsModal}
      {encerrarPsModal}
      <EfisModal
        show={showModal}
        title={`${tipoTexto === "A" ? "Motivo" : "Informação"}`}
        size="md"
        closeHandler={() => setShowModal(false)}
        primaryLabelVisible={false}
        secondaryLabel="Fechar"
        colorVariant="primary"
        body={
          <span
            dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(`${tipoTexto === "A" ? textoCancelamento : textoOsSpf}`),}}
          />
        }
      />

      <ParteServicoPaginatedView
        title="Parte de Serviço"
        keyField="sqParteServico"
        descriptionField="sqParteServico"
        defaultSearch
        defaultSearchPlaceholder="N° Parte de Serviço"
        advancedSearchFormik={formik}
        queryService={apiRoutes.fiscalizacao.parteservico.listaParteServicoPv}
        editRoute={`${match.url}/form`}
        columns={columns}
        permissionInsert={funcionalidades.parteServico.inserir}
        history={history}
        reduxKey={reduxKey}
        buttonTitle="Nova Parte de Serviço"
        origem=""
      >
        {showAdvancedSearch && form}
      </ParteServicoPaginatedView>
    </>
  );
};

export default ParteServico;
